import { Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useMember } from "api/members";
import { ReactComponent as HelpCircleIcon } from "components/Icons/help-circle.svg";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useMessage } from "hooks/intl";
import { useDebounce } from "hooks/useDebounce";
import { useEffect, useState } from "react";
import { useStyles } from "../SimulateCampaign.styles";
import { MemberDetailsTypes } from "./PersonDetails";

interface Props {
  name: string;
  setCustomerValues: (memberDetails: MemberDetailsTypes) => void;
  initialMemberId?: string;
}

export const MemberId = ({
  name,
  setCustomerValues,
  initialMemberId,
}: Props) => {
  const [value, setValue] = useState(initialMemberId || "");
  const { debouncedValue: memberId } = useDebounce(value);
  const { useMembersData } = useMember(memberId);
  const classes = useStyles();
  const { message } = useMessage();
  const { data: membersData } = useMembersData();

  useEffect(() => {
    membersData &&
      setCustomerValues({
        firstName: membersData?.firstName,
        lastName: membersData?.lastName,
        phone: membersData?.phone,
        email: membersData?.email,
        birthDate: membersData?.birthDate,
        levelId: membersData?.currentLevel?.levelId,
        levelAchievementDate: membersData?.levelAchievementDate,
        loyaltyCardNumber: membersData?.loyaltyCardNumber,
        gender: membersData?.gender,
        registeredDate: membersData?.registeredAt,
        segments: membersData?.segments,
        id: membersData?.customerId,
      });

    // eslint-disable-next-line
  }, [membersData]);

  return (
    <TextField
      className={classes.input}
      label={message({ id: "memberID" })}
      name={`${name}.id`}
      type="text"
      data-test-id="memberId"
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
      }}
      disabled={!!membersData}
      InputProps={{
        endAdornment: (
          <>
            {memberId.length > 0 && (
              <XCloseIcon
                className={classes.clearIcon}
                onClick={() => {
                  membersData &&
                    setCustomerValues({
                      firstName: "",
                      lastName: "",
                      phone: "",
                      email: "",
                      birthDate: undefined,
                      levelId: undefined,
                      levelAchievementDate: undefined,
                      loyaltyCardNumber: undefined,
                      gender: undefined,
                      registeredDate: "",
                      segments: undefined,
                      id: undefined,
                    });
                  setValue("");
                }}
              />
            )}

            <Tooltip
              text={
                <div>
                  <Typography className={classes.tooltipTitle}>
                    {message({ id: "memberID" })}
                  </Typography>
                  <Typography className={classes.tooltipDesc}>
                    {message({ id: "memberIdSimulation" })}
                  </Typography>
                </div>
              }
            >
              <HelpCircleIcon className={classes.infoIcon} />
            </Tooltip>
          </>
        ),
      }}
    />
  );
};
